import React, { useState, useEffect } from 'react';
import { db } from '../../firebase';
import { collection, onSnapshot, query, orderBy } from 'firebase/firestore';

const staticClientLogos = [
  { name: "Revel", svg: "REVEL" },
  { name: "Keller Williams Luxury", svg: "Keller Williams Luxury" },
  { name: "Sotheby's", svg: "SOTHEBY'S" },
  { name: "Compass", svg: "COMPASS" },
  { name: "The Agency", svg: "THE AGENCY" },
  { name: "RE/MAX", svg: "RE/MAX" },
  { name: "Chestnut Park", svg: "CHESTNUT PARK" },
  { name: "Cohen Homes", svg: "COHEN HOMES" },
  { name: "Royal LePage", svg: "ROYAL LEPAGE" },
  { name: "Nest Seekers", svg: "NEST SEEKERS" }
];

export const ClientLogos: React.FC = () => {
  const [logos, setLogos] = useState<any[]>(staticClientLogos);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(collection(db, 'clientLogos'), orderBy('order', 'asc'));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      if (!snapshot.empty) {
        const data = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setLogos(data);
      } else {
        setLogos(staticClientLogos);
      }
      setLoading(false);
    }, (error) => {
      console.error("Error fetching client logos:", error);
      setLogos(staticClientLogos);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading && logos.length === 0) return null;

  return (
    <section className="py-7 md:py-11 bg-white text-black overflow-hidden whitespace-nowrap border-y border-white">
        <div className="inline-flex animate-scroll hover:pause">
          {[...logos, ...logos, ...logos].map((logo, i) => (
            <div key={i} className="flex-shrink-0">
                <div className="mx-10 md:mx-16 flex items-center h-14 md:h-20 opacity-60 hover:opacity-100 transition-opacity duration-300">
                    <h3 className="font-display font-bold text-2xl md:text-3xl uppercase tracking-widest text-black/80 whitespace-nowrap">{logo.name || logo.svg}</h3>
                </div>
            </div>
          ))}
        </div>
    </section>
  );
};
